var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11.334 10.417h-5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h5a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625ZM2.166 10.417a.63.63 0 0 1-.625-.625v-3.85c0-2.041 1.658-3.7 3.7-3.7h4.683c2.142 0 3.7 1.425 3.7 3.384A.63.63 0 0 1 13 6.25a.63.63 0 0 1-.625-.625c0-1.467-1.275-2.134-2.45-2.134H5.241c-1.35 0-2.45 1.1-2.45 2.45v3.85c0 .35-.283.625-.625.625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M13.833 18.75H5.499a3.962 3.962 0 0 1-3.958-3.958V8.958A3.962 3.962 0 0 1 5.499 5h8.334a3.962 3.962 0 0 1 3.958 3.958v1.209a.63.63 0 0 1-.625.625h-.9c-.292 0-.558.108-.75.308l-.008.008a1.059 1.059 0 0 0-.284 1.034c.125.466.617.808 1.167.808h.775a.63.63 0 0 1 .625.625v1.208a3.964 3.964 0 0 1-3.958 3.967ZM5.499 6.25a2.714 2.714 0 0 0-2.708 2.708v5.834A2.714 2.714 0 0 0 5.499 17.5h8.334a2.714 2.714 0 0 0 2.708-2.708v-.584h-.15c-1.125 0-2.1-.708-2.375-1.733a2.315 2.315 0 0 1 .608-2.25 2.28 2.28 0 0 1 1.642-.683h.275v-.584a2.714 2.714 0 0 0-2.708-2.708H5.499Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M17.976 14.209h-1.609c-1.258 0-2.325-.934-2.425-2.134a2.288 2.288 0 0 1 .684-1.858 2.259 2.259 0 0 1 1.633-.675h1.708a1.48 1.48 0 0 1 1.484 1.475v1.717a1.467 1.467 0 0 1-1.475 1.475Zm-1.709-3.417c-.291 0-.558.108-.75.308a1.05 1.05 0 0 0-.325.867c.042.55.575.992 1.175.992h1.609c.125 0 .233-.1.233-.225v-1.717a.231.231 0 0 0-.233-.225h-1.709Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLight);
export default __webpack_public_path__ + "static/media/wallet-light.fb7074418c161e4add71e6cc3b670245.svg";
export { ForwardRef as ReactComponent };